import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClaimService } from '../services/claim/claim.service';
import { forLifeOf, LifecycleAware } from '../utilities/rxjs.helpers';

@LifecycleAware()
@Directive({
    selector: '[claimsOr]'
})
export class ClaimsOrDirective implements OnDestroy, OnInit {
    @Input() public claimsOr: number[];
    @Input() public claimsMissing?: TemplateRef<any>;
    private _hasEmbeddedView = false;

    constructor(
        public claimService: ClaimService,
        private _templateRef: TemplateRef<any>,
        private _viewContainerRef: ViewContainerRef
    ) {}

    public ngOnInit(): void {
        if (this.claimsOr && this.claimsOr.length) {
            const claimIsOnStreams = this.claimsOr.map((claim) => this.claimService.isOn(claim));
            combineLatest(...claimIsOnStreams)
                .pipe(
                    forLifeOf(this),
                    map((claimsAreOn) => claimsAreOn.some((claimIsOn) => claimIsOn))
                )
                .subscribe((someClaimIsOn) => {
                    if (someClaimIsOn) {
                        if (!this._hasEmbeddedView) {
                            this._viewContainerRef.createEmbeddedView(this._templateRef);
                            this._hasEmbeddedView = true;
                        }
                    } else {
                        this._viewContainerRef.clear();
                        this._hasEmbeddedView = false;

                        if (!!this.claimsMissing) {
                            this._viewContainerRef.createEmbeddedView(this.claimsMissing);
                            this._hasEmbeddedView = true;
                        }
                    }
                });
        } else if (!this._hasEmbeddedView) {
            this._viewContainerRef.createEmbeddedView(this._templateRef);
            this._hasEmbeddedView = true;
        }
    }

    public ngOnDestroy(): void {}
}
